export enum BetaFeatureToggleEnum {
  MemberPortal = 'MemberPortal',
  FormsV2 = 'FormsV2',
  Ecom = 'Ecom',
}
